/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRiskExclusionRequestBody,
  CreateRiskExclusionRequestBody$Outbound,
  CreateRiskExclusionRequestBody$outboundSchema,
} from "../components/createriskexclusionrequestbody.js";

export type CreateRiskExclusionSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRiskExclusionSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRiskExclusionSecurity = {
  option1?: CreateRiskExclusionSecurityOption1 | undefined;
  option2?: CreateRiskExclusionSecurityOption2 | undefined;
};

export type CreateRiskExclusionRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRiskExclusionRequestBody: CreateRiskExclusionRequestBody;
};

/** @internal */
export type CreateRiskExclusionSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRiskExclusionSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateRiskExclusionSecurityOption1$Outbound,
  CreateRiskExclusionSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createRiskExclusionSecurityOption1ToJSON(
  createRiskExclusionSecurityOption1: CreateRiskExclusionSecurityOption1,
): string {
  return JSON.stringify(
    CreateRiskExclusionSecurityOption1$outboundSchema.parse(
      createRiskExclusionSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRiskExclusionSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRiskExclusionSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateRiskExclusionSecurityOption2$Outbound,
  CreateRiskExclusionSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createRiskExclusionSecurityOption2ToJSON(
  createRiskExclusionSecurityOption2: CreateRiskExclusionSecurityOption2,
): string {
  return JSON.stringify(
    CreateRiskExclusionSecurityOption2$outboundSchema.parse(
      createRiskExclusionSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRiskExclusionSecurity$Outbound = {
  Option1?: CreateRiskExclusionSecurityOption1$Outbound | undefined;
  Option2?: CreateRiskExclusionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRiskExclusionSecurity$outboundSchema: z.ZodMiniType<
  CreateRiskExclusionSecurity$Outbound,
  CreateRiskExclusionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRiskExclusionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRiskExclusionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRiskExclusionSecurityToJSON(
  createRiskExclusionSecurity: CreateRiskExclusionSecurity,
): string {
  return JSON.stringify(
    CreateRiskExclusionSecurity$outboundSchema.parse(
      createRiskExclusionSecurity,
    ),
  );
}

/** @internal */
export type CreateRiskExclusionRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRiskExclusionRequestBody: CreateRiskExclusionRequestBody$Outbound;
};

/** @internal */
export const CreateRiskExclusionRequest$outboundSchema: z.ZodMiniType<
  CreateRiskExclusionRequest$Outbound,
  CreateRiskExclusionRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRiskExclusionRequestBody:
      CreateRiskExclusionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createRiskExclusionRequestBody: "CreateRiskExclusionRequestBody",
    });
  }),
);

export function createRiskExclusionRequestToJSON(
  createRiskExclusionRequest: CreateRiskExclusionRequest,
): string {
  return JSON.stringify(
    CreateRiskExclusionRequest$outboundSchema.parse(createRiskExclusionRequest),
  );
}
